import { toPlatePlugin } from '@udecode/plate/react';

import { BaseFootnotesPlugin } from '../lib';
import { BaseFootnoteEntryPlugin } from '../lib/BaseFootnoteEntryPlugin';

export const FootnotesPlugin = toPlatePlugin(BaseFootnotesPlugin);

export const FootnoteEntryPlugin = toPlatePlugin(BaseFootnoteEntryPlugin);
